import React, { useState } from 'react';
import { Button, Modal, Form, Input, DatePicker } from 'antd';
import CustomerPicker from "components/pickers/customer"
import InputNumber from "components/input-number"
import ImagePicker from "components/pickers/image/MultiImagePicker"
import DebtService from "services/debt"
import { useApp } from 'contexts/app';
import ComonFields from "./ComonFields"
import dayjs from 'dayjs';
const service = new DebtService();
const AddPayment = ({ onSaved, customer_id }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const { showNotify } = useApp();
    const showModal = () => {
        form.setFieldsValue({ date: dayjs(), customer_id })
        setIsModalOpen(true);
    };
    const handleOk = () => {
        form.submit();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        await service.createPayment(values);
        showNotify("Đã ghi nợ");
        if (onSaved) {
            onSaved();
        }
        setIsModalOpen(false)

    }
    return (
        <>
            <Button type="primary" onClick={showModal}>
                Thanh toán
            </Button>
            <Modal
                title="Thanh toán"
                closable={{ 'aria-label': 'Custom Close Button' }}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >

                <Form
                    layout={"vertical"}
                    form={form}
                    onFinish={onFinish}
                >

                    <Form.Item name="customer_id" label="Khách hàng"
                        rules={[{ required: true, message: "Bạn phải chọn khách hàng" }]}
                    >
                        <CustomerPicker style={{ width: "100%" }} disabled={customer_id ? true : false}></CustomerPicker>
                    </Form.Item>
                    <ComonFields></ComonFields>

                </Form>
            </Modal>
        </>
    );
};
export default AddPayment;